var React = require('react');

function IconLpFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.9967 21C41.9967 9.40625 32.5967 0 20.9984 0C9.40005 0 0 9.40078 0 21C0 32.5992 9.40551 42 20.9984 42C21.1208 42 21.2444 42 21.3669 41.9912V25.6506H16.8545V20.393H21.3658V16.5211C21.3658 12.0367 24.1 9.5889 28.1083 9.5889C29.4599 9.58269 30.8108 9.65133 32.1548 9.79453V14.4867H29.3988C27.2246 14.4867 26.7981 15.5192 26.7981 17.0373V20.3842H32.0072L31.3258 25.643H26.7981V41.1873C31.1792 39.9279 35.0317 37.2772 37.774 33.6356C40.5163 29.9939 41.9996 25.5589 42 21H41.9967Z","fill":"currentColor"}));
}

IconLpFacebook.defaultProps = {"width":"42","height":"42","fill":"none","role":"presentation","aria-hidden":"true","data-contrast":"svg-fill","className":"icon"};

module.exports = IconLpFacebook;

IconLpFacebook.default = IconLpFacebook;
